<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="section">
          <div class="section-content padding-top-20">
            <PlaybookSectionVideos :hideMoreToCome=true :videos = videoData videoGroup = "GETTING_STARTED" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlaybookSectionVideos from "@/components/playbook/PlaybookSectionVideos";
export default {
  name: "GettingStarted",
  components: { PlaybookSectionVideos },
  data() {
    return {
      videoData: [
        {
          id: 0,
          title: this.$t('PLAYBOOK.gettingStarted.howToWear'),
          src: "https://www.youtube-nocookie.com/embed/GijILvr7wUI?rel=0",
        },
        {
          id: 1,
          title: this.$t('PLAYBOOK.gettingStarted.howToWearHarness'),
          src: "https://www.youtube-nocookie.com/embed/Ryd5zknUXw0?rel=0",
        },
        {
          id: 2,
          title: this.$t('PLAYBOOK.gettingStarted.howToUseApp'),
          src: "https://www.youtube-nocookie.com/embed/MZAagcKvfMw?rel=0",
        },
        {
          id: 3,
           title: this.$t('PLAYBOOK.gettingStarted.heartRate'),
          src: "https://www.youtube-nocookie.com/embed/AcX1osPw-QU?rel=0",
        },
        {
          id: 4,
           title: this.$t('PLAYBOOK.gettingStarted.activeParticipation'),
          src: "https://www.youtube-nocookie.com/embed/7Ks53pjTIks?rel=0",
        },
        {
          id: 5,
          title: this.$t('PLAYBOOK.gettingStarted.workload'),
          src: "https://www.youtube-nocookie.com/embed/A-WMpLsxQ_E?rel=0",
        },
        {
          id: 6,
          title: this.$t('PLAYBOOK.gettingStarted.distance'),
          src: "https://www.youtube-nocookie.com/embed/SMZ86RJjSm4?rel=0",
        },
      ],
    };
  },
};
</script>

<style>
 .container-fluid .img-fluid{
   height: 500px;
 }

 .carousel.slide{
   padding: 0 10%;
 }

 .video-wrapper{
position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
 }
 .video-wrapper iframe{
position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
 }
</style>